import  { useState, useEffect } from "react";
import "./Homepage.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Carousel } from "react-bootstrap";
import Footer from "./Footer";
import Navbar from "./Navbar";
import FormsScroll from "./FormsScroll";
import BookConsultant from "../BookConsultant";
import { FaWhatsapp } from "react-icons/fa";
import { useAuth } from "../auth/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import { motion} from "framer-motion";
import { useRef } from "react";
import {AnimatePresence } from "framer-motion";
import AuthContainer from "../auth/AuthContainer";
import FeatureCards from "../components/upgraded/FeatureCards";
import HeroSection from "../components/upgraded/HeroSection";



//import Loader from "../components/loader";

// const generateSecureTokens = () => {
//   const t1 = crypto.randomUUID() + crypto.randomUUID();
//   const t2 = crypto.randomUUID() + crypto.randomUUID();
//   return { t1, t2 };
// };


const Home = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [isBookConsultantOpen, setIsBookConsultantOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isChatOpen, setIsChatOpen] = useState(false);

  const [initialAuthMode, setInitialAuthMode] = useState("login");

  
  const [visitCount, setVisitCount] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const { user,loading } = useAuth();
  const aboutRef = useRef(null);
  const [heroIndex, setHeroIndex] = useState(0);
  const [isAnimatingPanel, setIsAnimatingPanel] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

// ✅ FIXED: Changed initial states from true to false
const [showHeroCard, setShowHeroCard] = useState(false);   // 🔥 START HIDDEN
const [showHeroText, setShowHeroText] = useState(false);   // 🔥 START HIDDEN


const [pendingIndex, setPendingIndex] = useState(null);
const [showHeroPara, setShowHeroPara] = useState(false);  // 🔥 START HIDDEN
// eslint-disable-next-line no-unused-vars
const [allowSmallCard, setAllowSmallCard] = useState(false);
const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [mobileCardVisible, setMobileCardVisible] = useState(false);
const [mobileHeadingVisible, setMobileHeadingVisible] = useState(false);
const [mobileParaVisible, setMobileParaVisible] = useState(false);
const mobileSweep = false;



useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


const headingContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: isMobile ? 0.55 : 0.48, // ⭐ slower on mobile
      delayChildren: isMobile ? 0.35 : 0.2,
    },
  },
};


const headingItem = {
  hidden: { 
    opacity: 0,
    x: -60,
  },

  show: {
    opacity: 1,
    x: 0,

    transition: {
      duration: isMobile ? 1.25 : 0.85,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};




const paragraphVariant = {
  hidden: { opacity: 0, x: -25 },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: isMobile ? 0.9 : 0.55, // ⭐ MUCH smoother
      delay: isMobile ? 0.25 : 0.41,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};





const textContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const textItem = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0 },
};
  useEffect(() => {
  if (user) {
    const pendingAction = localStorage.getItem("postAuthAction");
    const pendingProtectedRedirect =
      sessionStorage.getItem("postLoginRedirect") ||
      localStorage.getItem("postLoginRedirect");
    const params = new URLSearchParams(location.search);
    const hasAuthModalFlow =
      params.has("openLogin") || params.has("verifyToken");

    // Home should not override redirects during auth handoff flows.
    // Also do not redirect if we are explicitly scrolling to a section (e.g., from the Sidebar "About" link)
    const scrollTarget = location.state?.scrollTo;
    if (!pendingAction && !pendingProtectedRedirect && !hasAuthModalFlow && !scrollTarget) {
      navigate("/dashboard", { replace: true });
    }
  }
}, [user, navigate, location.search, location.state]);

  // Scroll to section on load if requested in state
  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    }
  }, [location.state]);


  // POPUP STATE (SUCCESS / FAILURE)
  const [showPopup, setShowPopup] = useState({
    visible: false,
    message: "",
  });

useEffect(() => {
  async function fetchVisitCount() {
    const response = await fetch (`${process.env.REACT_APP_BACKEND_URL}/visitor/visit-count`) 
    const data = await response.json();
    setVisitCount(data.count);  
  }
  fetchVisitCount();
}
, []);


useEffect(() => {
  const visited = localStorage.getItem("visited");

  if (!visited) {
    localStorage.setItem("visited", "true"); // 🔥 set first

    fetch(`${process.env.REACT_APP_BACKEND_URL}/visitor/visit`, {
      method: "POST",
    }).catch(() => {
      // optional rollback if needed
      localStorage.removeItem("visited");
    });
  }
}, []);

useEffect(() => {
  const items = document.querySelectorAll(".animate-item");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
        }
      });
    },
    { threshold: 0.25 }
  );

  items.forEach((item) => observer.observe(item));

  return () => observer.disconnect();
}, []);

// ✅ FIXED: Initial animation trigger - handles both mobile and desktop
useEffect(() => {
  const timer = setTimeout(() => {
    if (isMobile) {
      // Mobile: Show everything immediately on first load
      setMobileCardVisible(true);
      setTimeout(() => {
        setMobileHeadingVisible(true);
        setTimeout(() => {
          setMobileParaVisible(true);
        }, 1700);
      }, 500);
    } else {
      // Desktop: Sequential animation
      setShowHeroCard(true);
      setTimeout(() => {
        setShowHeroText(true);
        setTimeout(() => {
          setShowHeroPara(true);
        }, 1200);
      }, 200);
    }
  }, 100);
  
  return () => clearTimeout(timer);
}, [isMobile]); // Re-run if screen size changes

// ✅ Desktop auto-slide - matches mobile 12s timing
const desktopSlideIndex = useRef(0);

useEffect(() => {
  if (isMobile) return;

  const TOTAL_SLIDES = 3;
  const DISPLAY_TIME = 7000; // ✅ same as mobile interval={12000}

  let timeout;

  const goToNextSlide = () => {
    timeout = setTimeout(() => {
      desktopSlideIndex.current = (desktopSlideIndex.current + 1) % TOTAL_SLIDES;
      const nextIndex = desktopSlideIndex.current;

      setShowHeroText(false);
      setShowHeroCard(false);
      setShowHeroPara(false);
      setAllowSmallCard(false);
      setPendingIndex(nextIndex);
      setIsAnimatingPanel(true);
      setHeroIndex(nextIndex);

      setTimeout(() => {
        setIsAnimatingPanel(false);
        setAllowSmallCard(true);
        setShowHeroCard(true);

        setTimeout(() => {
          setShowHeroText(true);

          setTimeout(() => {
            setShowHeroPara(true);
            goToNextSlide(); // ✅ schedule next only after full animation
          }, 1200);
        }, 200);
      }, 1000);

    }, DISPLAY_TIME);
  };

  goToNextSlide();

  return () => clearTimeout(timeout);
}, [isMobile]);

  if (loading) return null;

 const handleServiceClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (!isLoggedIn) {
      setShowLogin(true);
    }
  };




// 🔥 UNIVERSAL SCROLL ANIMATION
const scrollReveal = {
  hidden: {
    opacity: 0,
    y: 80,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1], // ultra smooth
    },
  },
};



  return (
    <>
      {/* ==============================
          TOP PAYMENT POPUP
      =============================== */}
      {showPopup.visible && (
        <div className="top-popup-o">
          <div className="top-popup-box">
            <h4>{showPopup.message}</h4>
            <button
              onClick={() => {
                // Call onClose callback if it exists (for BookConsultant drawer)
                if (showPopup.onClose) {
                  showPopup.onClose();
                }
                setShowPopup({ visible: false, message: "" });
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <div>
        <div className="hero-wrapper" id="home">

        <Navbar
  openLogin={() => {
    setInitialAuthMode("login");
    setShowLogin(true);
  }}
   onMenuToggle={(state) => setNavOpen(state)}
/>

        {/* NEW ANIMATED HERO */}
        <HeroSection
          onGetStarted={() => navigate('/dashboard')}
          onSeeDemo={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
          onBookConsultant={() => setIsBookConsultantOpen(true)}
        />

        {/* HERO AREA (legacy carousel — hidden in favor of HeroSection) */}
        <div className="thisisfirstcarousal" style={{ display: "none" }}>
          {/* FULL BANNER GREY SWEEP */}
<AnimatePresence>
 {isAnimatingPanel && (
  <motion.div
    className={pendingIndex % 2 !== 0 ? "hero-arrow-left" : "hero-arrow-right"}
    initial={{ x: pendingIndex % 2 !== 0 ? "-100%" : "100%" }}
    animate={{ x: pendingIndex % 2 !== 0 ? "100%" : "-100%" }}
    transition={{
      duration: 4.25,
      ease: [0.22, 1, 0.36, 1],
    }}
    onUpdate={(latest) => {
      if (pendingIndex !== null) {
        const x = parseFloat(latest.x);
        if (x <= -200 || x >= 200) {
          setHeroIndex(pendingIndex);
          setPendingIndex(null);
        }
      }
    }}
    onAnimationComplete={() => {
      setIsAnimatingPanel(false);
      setAllowSmallCard(true);
      setShowHeroCard(true);
      setTimeout(() => {
        setShowHeroText(true);
      }, 200);
    }}
  />
)}
</AnimatePresence>

{isMobile ? (

/* ================= MOBILE HERO ================= */

<Carousel
  indicators
  controls={false}
  interval={12000}
  touch
  pause={false}

 onSlide={(nextIndex) => {

  // hide everything
  setMobileCardVisible(false);
  setMobileHeadingVisible(false);
  setMobileParaVisible(false);

  setPendingIndex(nextIndex);

  // START BIG SWEEP
  setIsAnimatingPanel(true);

  // AFTER sweep finishes
  setTimeout(() => {

    setIsAnimatingPanel(false);

    setTimeout(()=>{
      setMobileCardVisible(true);

      setTimeout(()=>{
        setMobileHeadingVisible(true);

        setTimeout(()=>{
          setMobileParaVisible(true);
        },1700);

      },500);

    },200);

  },1000); // match desktop timing
}}


>


<Carousel.Item>
 <div className="mobileHero" style={{ height: navOpen ? "85vh" : "72vh" }}>

   <img src="/image/slidee1.png" className="mobileHeroImg slidee1Focus" alt="slide 1" />

    <div className="mobileOverlay" />

    <AnimatePresence>
  {mobileSweep && (
   <motion.div
  className="mobileBigSweep"
  initial={{ x: pendingIndex % 2 !== 0 ? "100%" : "-100%" }}
  animate={{ x: pendingIndex % 2 !== 0 ? "-100%" : "100%" }}
  exit={{ x: pendingIndex % 2 !== 0 ? "-100%" : "100%" }}
      transition={{
        duration: 0.65,
        ease: [0.22,1,0.36,1],
      }}
    />
  )}
</AnimatePresence>


   <motion.div
  className="mobileCard"
   style={{
  bottom: "110px"
}}
  initial={{ x: -120, opacity: 0 }}
  animate={{
    x: mobileCardVisible ? 0 : -120,
    opacity: mobileCardVisible ? 1 : 0
  }}
  transition={{
    duration: 0.65,
    ease: [0.22,1,0.36,1]
  }}
>
  <motion.div
  className="mobileRevealMask"
  initial={{ scaleX: 1, transformOrigin: "left" }}
  animate={{
    scaleX: mobileCardVisible ? 0 : 1,
    transformOrigin: "right"
  }}
  transition={{
    duration: 0.8,
    ease: [0.22,1,0.36,1]
  }}
/>

     <motion.h2
  variants={headingContainer}
  initial="hidden"
  animate={mobileHeadingVisible ? "show" : "hidden"}
>
  <motion.span variants={headingItem}>
    Clear
  </motion.span>
  <br/>

  <motion.span variants={headingItem}>
    <span>and</span>
  </motion.span>
  <br/>

  <motion.span variants={headingItem}>
    Strategic
  </motion.span>
</motion.h2>


      <motion.p
  variants={paragraphVariant}
  initial="hidden"
  animate={mobileParaVisible ? "show" : "hidden"}
>
       Empowering businesses with tailored
e-commerce solutions and expert consulting to streamline operations, boost sales, and drive growth.
      </motion.p>
      <div style={{
        position: 'absolute',
        bottom: 20,
        left: 20,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}>
        <button
          className="book-btn"
          onClick={() => setIsBookConsultantOpen(true)}
          style={{
            position: 'static',
            margin: 0,
            padding: '10px 14px',
            fontSize: '14px',
            height: 'auto',
          }}
        >
          Book Consultant
        </button>
        <a
          href="https://wa.me/919494075914?text=Hi"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: 'linear-gradient(to TOP, #fd7e2f, #f63737)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
            color: 'white',
          }}
        >
          <FaWhatsapp size={20} />
        </a>
      </div>
    </motion.div>

  </div>
</Carousel.Item>


 <Carousel.Item>
 <div className="mobileHero" style={{ height: navOpen ? "85vh" : "72vh" }}>

    <img src="/image/slide3.png" className="mobileHeroImg" alt="slide 2" />

    <div className="mobileOverlay" />

    <AnimatePresence>
  {mobileSweep && (
    <motion.div
  className="mobileBigSweep"
  initial={{ x: pendingIndex % 2 !== 0 ? "100%" : "-100%" }}
  animate={{ x: pendingIndex % 2 !== 0 ? "-100%" : "100%" }}
  exit={{ x: pendingIndex % 2 !== 0 ? "-100%" : "100%" }}
      transition={{
        duration: 0.65,
        ease: [0.22,1,0.36,1],
      }}
    />
  )}
</AnimatePresence>


  <motion.div
  className="mobileCard"
  style={{
  bottom: "95px"
}}
  initial={{ x: -120, opacity: 0 }}
  animate={{
    x: mobileCardVisible ? 0 : -120,
    opacity: mobileCardVisible ? 1 : 0
  }}
  transition={{
    duration: 0.65,
    ease: [0.22,1,0.36,1]
  }}
>

<motion.div
  className="mobileRevealMask"
  initial={{ scaleX: 1, transformOrigin: "left" }}
  animate={{
    scaleX: mobileCardVisible ? 0 : 1,
    transformOrigin: "right"
  }}
  transition={{
    duration: 0.8,
    ease: [0.22,1,0.36,1]
  }}
/>

      <motion.h2
  variants={headingContainer}
  initial="hidden"
  animate={mobileHeadingVisible ? "show" : "hidden"}
>
  <motion.span variants={headingItem}>
    Modern
  </motion.span>
  <br/>

  <motion.span variants={headingItem}>
    <span>and</span>
  </motion.span>
  <br/>

  <motion.span variants={headingItem}>
    Bold
  </motion.span>
</motion.h2>


     <motion.p
  variants={paragraphVariant}
  initial="hidden"
  animate={mobileParaVisible ? "show" : "hidden"}
>
       Fueling success through innovative e-commerce platforms and smart consultancy that simplify processes and accelerate your digital transformation journey.
      </motion.p>
    </motion.div>

  </div>
</Carousel.Item>


 <Carousel.Item>
 <div className="mobileHero" style={{ height: navOpen ? "85vh" : "72vh" }}>

    <img src="/image/slidee2.png" className="mobileHeroImg" alt="slide 3" />

    <div className="mobileOverlay" />

    <AnimatePresence>
  {mobileSweep && (
   <motion.div
  className="mobileBigSweep"
  initial={{ x: pendingIndex % 2 !== 0 ? "100%" : "-100%" }}
  animate={{ x: pendingIndex % 2 !== 0 ? "-100%" : "100%" }}
  exit={{ x: pendingIndex % 2 !== 0 ? "-100%" : "100%" }}
      transition={{
        duration: 0.65,
        ease: [0.22,1,0.36,1],
      }}
    />
  )}
</AnimatePresence>


  <motion.div
  className="mobileCard"
  style={{
  bottom: "110px"
}}
  initial={{ x: -120, opacity: 0 }}
  animate={{
    x: mobileCardVisible ? 0 : -120,
    opacity: mobileCardVisible ? 1 : 0
  }}
  transition={{
    duration: 0.65,
    ease: [0.22,1,0.36,1]
  }}
>

<motion.div
  className="mobileRevealMask"
  initial={{ scaleX: 1, transformOrigin: "left" }}
  animate={{
    scaleX: mobileCardVisible ? 0 : 1,
    transformOrigin: "right"
  }}
  transition={{
    duration: 0.8,
    ease: [0.22,1,0.36,1]
  }}
/>

     <motion.h2
  variants={headingContainer}
  initial="hidden"
  animate={mobileHeadingVisible ? "show" : "hidden"}
>
  <motion.span variants={headingItem}>
    Trust
  </motion.span>
  <br/>

  <motion.span variants={headingItem}>
    <span>and</span>
  </motion.span>
  <br/>

  <motion.span variants={headingItem}>
    Focused
  </motion.span>
</motion.h2>


     <motion.p
  variants={paragraphVariant}
  initial="hidden"
  animate={mobileParaVisible ? "show" : "hidden"}
>
       Combining technology and expertise to deliver scalable e-commerce strategies that enhance efficiency, profitability, and long-term business performance.
      </motion.p>
    </motion.div>

  </div>
</Carousel.Item>


</Carousel>

) : (





          <section id="whys" className="why_section hero-full">
<Carousel
  activeIndex={heroIndex}
onSelect={(nextIndex) => {
  setShowHeroText(false);
  setShowHeroCard(false);
  setShowHeroPara(false);
  setAllowSmallCard(false);

  setPendingIndex(nextIndex);
  setHeroIndex(nextIndex);
  setIsAnimatingPanel(true);

  setTimeout(() => {
    setIsAnimatingPanel(false);
    setAllowSmallCard(true);
    setShowHeroCard(true);

    setTimeout(() => {
      setShowHeroText(true);
      setTimeout(() => {
        setShowHeroPara(true);
      }, 1200);
    }, 200);
  }, 1000);
}}
   interval={null}     // 🔥 IMPORTANT
  slide={false}       // 🔥 DISABLE bootstrap animation
  fade={false} 
  indicators
  controls={false}
>

   {/* Slide 1 */}
            <Carousel.Item
  className="hero-slide"
  style={{ backgroundImage: "url('/image/slidee1.png')" }}
>
 <div className="row why-slide" style={{ visibility: isAnimatingPanel ? "hidden" : "visible" }}>

    {/* LEFT CONTENT */}
   <motion.div className="col-md-6 hero-left-wrapper">

  {/* 🔥 CARD SIZE CONTROLLER */}
 <div className="hero-card-stack">

  {/* ORANGE REVEAL MASK (TEMPORARY) - BALANCED ANIMATION */}

  <motion.div
    className="hero-reveal-mask"
    initial={{ scaleX: 1, transformOrigin: "left" }}
    animate={
      showHeroCard
        ? { scaleX: 0, transformOrigin: "right" }
        : { scaleX: 1, transformOrigin: "left" }
    }
    transition={{
      duration: 1.5,  // BALANCED - not too fast, not too slow
      ease: [0.22, 1, 0.36, 1],
    }}
  />





  {/* BLACK CARD (REAL CONTENT) */}
  <div className="hero-content-box">

  <motion.h3
  className="why-title"
  variants={headingContainer}
  initial="hidden"
  animate={showHeroText ? "show" : "hidden"}
>
  <motion.span variants={headingItem} className="line">
    Clear
  </motion.span>
  <br />

  <motion.span variants={headingItem} className="line and-text">
    and
  </motion.span>
  <br />

  <motion.span variants={headingItem} className="line bold">
    Strategic
  </motion.span>
</motion.h3>

    <motion.p
  key={`para-slide-1-${heroIndex}`}
  className="why-desc"
  variants={paragraphVariant}
  initial="hidden"
  animate={showHeroPara ? "show" : "hidden"}
>

      Empowering businesses with tailored <br/>
       e-commerce solutions and expert consulting to 
       streamline operations, boost sales, and drive 
       growth.
    </motion.p>

  </div>
</div>

</motion.div>


   

  </div>
  
</Carousel.Item>




                {/* Slide 2 */}
            <Carousel.Item
  className="hero-slide"
  style={{ backgroundImage: "url('/image/slide3.png')" }}
>
 <div className="row why-slide" style={{ visibility: isAnimatingPanel ? "hidden" : "visible" }}>

    {/* LEFT CONTENT */}
   <motion.div className="col-md-6 ms-auto hero-right-wrapper">


  {/* 🔥 CARD SIZE CONTROLLER */}
 <div className="hero-card-stack">

  {/* ORANGE REVEAL MASK (TEMPORARY) - BALANCED ANIMATION */}
 
  <motion.div
    className="hero-reveal-mask"
    initial={{ scaleX: 1, transformOrigin: "left" }}
    animate={
      showHeroCard
        ? { scaleX: 0, transformOrigin: "right" }
        : { scaleX: 1, transformOrigin: "left" }
    }
    transition={{
      duration: 1.5,  // BALANCED - not too fast, not too slow
      ease: [0.22, 1, 0.36, 1],
    }}
  />




  {/* BLACK CARD (REAL CONTENT) */}
  <div className="hero-content-box">

  <motion.h3
  className="why-title"
  variants={headingContainer}
  initial="hidden"
  animate={showHeroText ? "show" : "hidden"}
>
  <motion.span variants={headingItem} className="line">
    Modern
  </motion.span>
  <br />

  <motion.span variants={headingItem} className="line and-text">
    and
  </motion.span>
  <br />

  <motion.span variants={headingItem} className="line bold">
    Bold
  </motion.span>
</motion.h3>


    <motion.p
  key={`para-slide-2-${heroIndex}`}
  className="why-desc"
  variants={paragraphVariant}
  initial="hidden"
  animate={showHeroPara ? "show" : "hidden"}
>
      Fueling success through innovative e-commerce platforms and smart consultancy that simplify processes and accelerate your digital transformation journey.
    </motion.p>

  </div>
</div>

</motion.div>


   

  </div>
</Carousel.Item>


                {/* Slide 3 */}
              <Carousel.Item
  className="hero-slide"
  style={{ backgroundImage: "url('/image/slidee2.png')" }}
>
 <div className="row why-slide" style={{ visibility: isAnimatingPanel ? "hidden" : "visible" }}>

    {/* LEFT CONTENT */}
   <motion.div className="col-md-6 hero-left-wrapper">

  {/* 🔥 CARD SIZE CONTROLLER */}
 <div className="hero-card-stack">

  {/* ORANGE REVEAL MASK (TEMPORARY) - BALANCED ANIMATION */}
 
  <motion.div
    className="hero-reveal-mask"
    initial={{ scaleX: 1, transformOrigin: "left" }}
    animate={
      showHeroCard
        ? { scaleX: 0, transformOrigin: "right" }
        : { scaleX: 1, transformOrigin: "left" }
    }
    transition={{
      duration: 1.5,  // BALANCED - not too fast, not too slow
      ease: [0.22, 1, 0.36, 1],
    }}
  />

{/* BLACK CARD (REAL CONTENT) */}
  <div className="hero-content-box">

 <motion.h3
  className="why-title"
  variants={headingContainer}
  initial="hidden"
  animate={showHeroText ? "show" : "hidden"}
>
  <motion.span variants={headingItem} className="line">
    Trust
  </motion.span>
  <br />

  <motion.span variants={headingItem} className="line and-text">
    and
  </motion.span>
  <br />

  <motion.span variants={headingItem} className="line bold">
    Focused
  </motion.span>
</motion.h3>


    <motion.p
  key={`para-slide-3-${heroIndex}`}
  className="why-desc"
  variants={paragraphVariant}
  initial="hidden"
  animate={showHeroPara ? "show" : "hidden"}
>
      Combining technology and expertise to deliver scalable e-commerce strategies that enhance efficiency, profitability, and long-term business performance.
    </motion.p>

  </div>
</div>

</motion.div>


   

  </div>
</Carousel.Item>


              </Carousel>
            
          </section>
)}
        </div>
        </div>
        </div>

      {/* ABOUT SECTION */}
      <motion.section
        id="about"
        className="about_section"
        ref={aboutRef}
        variants={scrollReveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {/* Grid texture overlay — same as FeatureCards */}
        <div className="about-grid-texture" />
        {/* Ambient glow orbs */}
        <div className="about-glow-orb about-glow-orb--left" />
        <div className="about-glow-orb about-glow-orb--right" />

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          {/* Section header */}
          <div className="aboutusparent">
            <div style={{ marginBottom: "10px" }}>
              <span className="section-pill">Our Story</span>
            </div>
            <h2 className="aboutussss">
              <span className="about-title">About</span>
              <span className="text-lightsky">Marsmate</span>
            </h2>
          </div>

          <div className="row align-items-center about-animate">

            {/* Left — SVG orbital diagram */}
            <motion.div
              className="col-lg-6 col-md-12 about-image-col"
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
              <svg className="about-svg" viewBox="0 0 500 500" width="100%" height="100%">
                <defs>
                  <linearGradient id="marsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#ff5e00" />
                    <stop offset="50%" stopColor="#ff007f" />
                    <stop offset="100%" stopColor="#7000ff" />
                  </linearGradient>
                  <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#ff5e00" stopOpacity="0.8" />
                    <stop offset="50%" stopColor="#00f0ff" stopOpacity="0.2" />
                    <stop offset="100%" stopColor="#7000ff" stopOpacity="0.8" />
                  </linearGradient>
                  <filter id="aboutGlow" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="8" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                  </filter>
                  <filter id="cardShadow" x="-10%" y="-10%" width="130%" height="130%">
                    <feDropShadow dx="0" dy="8" stdDeviation="8" floodColor="#000" floodOpacity="0.3" />
                  </filter>
                </defs>
                <circle cx="250" cy="250" r="160" fill="#ff5e00" opacity="0.04" className="pulse-slow" />
                <g stroke="url(#ringGrad)" strokeWidth="2" strokeDasharray="8 6" className="mind-connections" opacity="0.6">
                  <line x1="250" y1="250" x2="110" y2="150" />
                  <line x1="250" y1="250" x2="390" y2="150" />
                  <line x1="250" y1="250" x2="110" y2="350" />
                  <line x1="250" y1="250" x2="390" y2="350" />
                </g>
                <ellipse cx="250" cy="250" rx="190" ry="80" fill="none" stroke="url(#ringGrad)" strokeWidth="2" transform="rotate(-15 250 250)" />
                <ellipse cx="250" cy="250" rx="140" ry="60" fill="none" stroke="url(#ringGrad)" strokeWidth="1.5" transform="rotate(25 250 250)" opacity="0.5" />
                <g className="floating-illustration" filter="url(#cardShadow)">
                  <circle cx="250" cy="250" r="55" fill="url(#marsGrad)" filter="url(#aboutGlow)" />
                  <path d="M 200 250 Q 250 280 300 250 M 205 230 Q 250 255 295 230 M 205 270 Q 250 295 295 270 M 250 195 Q 225 250 250 305" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
                  <text x="250" y="254" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle" letterSpacing="1" fontFamily="Montserrat, sans-serif">MARSMATE</text>
                </g>
                <g transform="translate(110, 150)" filter="url(#cardShadow)">
                  <g className="floating-illustration">
                    <rect x="-45" y="-35" width="90" height="70" rx="12" fill="#171717" stroke="#ff5e00" strokeWidth="2" />
                    <path d="M 0 -15 C -6 -15 -10 -11 -10 -5 C -10 -1 -7 2 -5 5 H 5 C 7 2 10 -1 10 -5 C 10 -11 6 -15 0 -15 Z" fill="none" stroke="#ff5e00" strokeWidth="1.5" />
                    <line x1="-3" y1="9" x2="3" y2="9" stroke="#ff5e00" strokeWidth="1.5" />
                    <text x="0" y="24" fill="#eee" fontSize="8" fontWeight="bold" textAnchor="middle" fontFamily="Barlow, sans-serif">Validation</text>
                  </g>
                </g>
                <g transform="translate(390, 150)" filter="url(#cardShadow)">
                  <g className="floating-illustration-alt">
                    <rect x="-45" y="-35" width="90" height="70" rx="12" fill="#171717" stroke="#00f0ff" strokeWidth="2" />
                    <path d="M -8 -8 H 0 A 4 4 0 0 1 8 -8 H 8 V 0 A 4 4 0 0 0 8 8 H -8 Z" fill="none" stroke="#00f0ff" strokeWidth="1.5" />
                    <circle cx="0" cy="0" r="3" fill="#ff007f" />
                    <text x="0" y="24" fill="#eee" fontSize="8" fontWeight="bold" textAnchor="middle" fontFamily="Barlow, sans-serif">Tech Match</text>
                  </g>
                </g>
                <g transform="translate(110, 350)" filter="url(#cardShadow)">
                  <g className="floating-illustration-alt">
                    <rect x="-45" y="-35" width="90" height="70" rx="12" fill="#171717" stroke="#7000ff" strokeWidth="2" />
                    <circle cx="0" cy="-5" r="8" fill="none" stroke="#7000ff" strokeWidth="2.5" strokeDasharray="4 2" />
                    <circle cx="0" cy="-5" r="3" fill="#7000ff" />
                    <text x="0" y="24" fill="#eee" fontSize="8" fontWeight="bold" textAnchor="middle" fontFamily="Barlow, sans-serif">AI Engine</text>
                  </g>
                </g>
                <g transform="translate(390, 350)" filter="url(#cardShadow)">
                  <g className="floating-illustration">
                    <rect x="-45" y="-35" width="90" height="70" rx="12" fill="#171717" stroke="#00ff66" strokeWidth="2" />
                    <path d="M -10 -9 L -15 -4 L -10 1 M 10 -9 L 15 -4 L 10 1" fill="none" stroke="#00ff66" strokeWidth="1.5" strokeLinecap="round" />
                    <line x1="3" y1="-10" x2="-3" y2="2" stroke="#00ff66" strokeWidth="1.5" />
                    <text x="0" y="24" fill="#eee" fontSize="8" fontWeight="bold" textAnchor="middle" fontFamily="Barlow, sans-serif">Development</text>
                  </g>
                </g>
              </svg>
            </motion.div>

            {/* Right — redesigned content panels */}
            <motion.div
              className="col-lg-6 col-md-12 about-content-right"
              variants={textContainer}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
            >
              {/* Title card */}
              <motion.div variants={textItem} className="about-title-badge">
                <span className="about-title-dot" />
                We Are MarsMate AI
              </motion.div>

              {/* Main description — glass card */}
              <motion.div variants={textItem} className="about-glass-card">
                <p>
                  MarsMate AI is a next-generation <strong>Plug &amp; Play Technology Platform</strong> built
                  to reduce R&amp;D effort, accelerate launches, and match founders with the right tech and talent.
                </p>
                <p>
                  Whether you're validating a new business idea, building a scalable product, or seeking
                  the right investors — MarsMate AI is your all-in-one launch co-pilot.
                </p>
              </motion.div>

              {/* Stats row */}
              <motion.div variants={textItem} className="about-stats-row">
                {[
                  { num: "50+", label: "Clients Served" },
                  { num: "4",   label: "Core Services" },
                  { num: "AI",  label: "Powered Engine" },
                  { num: "24/7",label: "Support" },
                ].map((s) => (
                  <div className="about-stat-card" key={s.label}>
                    <span className="about-stat-num">{s.num}</span>
                    <span className="about-stat-label">{s.label}</span>
                  </div>
                ))}
              </motion.div>

              {/* What We Offer — offer card */}
              <motion.div variants={textItem} className="about-offer-card">
                <div className="about-offer-header">
                  <span className="about-offer-dot" />
                  What We Offer
                </div>
                <div className="about-offer-tags">
                  {[
                    "Idea Validation & Tracker",
                    "Plug & Play Tech & Match",
                    "Gen Niche Tech Engine",
                    "Web & App Development",
                  ].map((item) => (
                    <span className="about-offer-tag" key={item}>{item}</span>
                  ))}
                </div>
              </motion.div>

            </motion.div>

          </div>
        </div>
      </motion.section>

      {/* FEATURE CARDS — animated 3D tilt showcase */}
      <section id="features" className="features_section layout_padding">
        <FeatureCards
          title="Everything you need to launch"
          subtitle="From idea to validation to launch — one AI-native platform built for founders."
        />
      </section>

      {/* SERVICES */}
      <motion.section
        id="services"
        className="service_section layout_padding"
        variants={scrollReveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
      >
        <div className="svc-grid-texture" />

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="heading_container heading_center">
            <div><span className="section-pill">What We Do</span></div>
            <h2>Our <span>Services</span></h2>
          </div>

          <div className="svc-grid">

            {/* Service 1 — Idea Validation */}
            {[
              {
                accent: "#ff5e00", accentAlt: "#ff9900",
                badge: "AI Powered", badgeBg: "rgba(255,94,0,0.1)", badgeBorder: "rgba(255,94,0,0.3)",
                title: "Idea Validation",
                desc: "Validate your startup ideas with real-time market analysis, AI scoring, and competitive intelligence.",
                tag: "Validate → Refine → Launch",
                svg: (
                  <svg className="service-svg" viewBox="0 0 100 100" width="72" height="72">
                    <defs>
                      <linearGradient id="bulbGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#ff5e00"/><stop offset="100%" stopColor="#ff9900"/></linearGradient>
                      <filter id="glowS1"><feGaussianBlur stdDeviation="2.5" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
                    </defs>
                    <path d="M 50 15 A 25 25 0 0 0 30 55 C 30 65 40 70 40 80 H 60 C 60 70 70 65 70 55 A 25 25 0 0 0 50 15 Z" fill="none" stroke="url(#bulbGrad)" strokeWidth="3" filter="url(#glowS1)"/>
                    <path d="M 50 25 L 42 45 H 48 L 46 65 L 58 40 H 52 Z" fill="#ff5e00" className="pulse-slow"/>
                    <rect x="43" y="81" width="14" height="4" rx="2" fill="#888"/>
                    <rect x="45" y="86" width="10" height="4" rx="2" fill="#888"/>
                    <circle cx="20" cy="30" r="3" fill="#ff007f" className="blink-fast"/>
                    <circle cx="80" cy="40" r="2" fill="#00f0ff" className="blink-slow"/>
                  </svg>
                ),
              },
              {
                accent: "#00c6ff", accentAlt: "#7000ff",
                badge: "BI Engine", badgeBg: "rgba(0,198,255,0.1)", badgeBorder: "rgba(0,198,255,0.3)",
                title: "Business Matching",
                desc: "Leverage Business Intelligence to find the right niche, co-founders, investors, and tech partners.",
                tag: "Match → Connect → Grow",
                svg: (
                  <svg className="service-svg" viewBox="0 0 100 100" width="72" height="72">
                    <defs>
                      <linearGradient id="matchGrad1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#00f0ff"/><stop offset="100%" stopColor="#7000ff"/></linearGradient>
                      <linearGradient id="matchGrad2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#ff007f"/><stop offset="100%" stopColor="#ff5e00"/></linearGradient>
                    </defs>
                    <g transform="translate(10, 20) scale(0.95)"><g className="floating-illustration"><path d="M 10 10 H 30 A 10 10 0 0 1 50 10 H 70 V 30 A 10 10 0 0 0 70 50 V 70 H 10 V 10 Z" fill="url(#matchGrad1)" opacity="0.9"/></g></g>
                    <g transform="translate(38, 28) scale(0.95)"><g className="floating-illustration-alt"><path d="M 10 10 H 30 V 30 A 10 10 0 0 1 30 50 V 70 H 10 A 10 10 0 0 0 10 50 V 30 Z" fill="url(#matchGrad2)" opacity="0.95"/></g></g>
                    <circle cx="50" cy="50" r="5" fill="#00ff66" className="pulse-slow"/>
                  </svg>
                ),
              },
              {
                accent: "#7000ff", accentAlt: "#00f0ff",
                badge: "Dev Team", badgeBg: "rgba(112,0,255,0.1)", badgeBorder: "rgba(112,0,255,0.3)",
                title: "Software Development",
                desc: "End-to-end web & app development with modern frameworks, APIs, and AI-integrated solutions.",
                tag: "Design → Build → Deploy",
                svg: (
                  <svg className="service-svg" viewBox="0 0 100 100" width="72" height="72">
                    <defs><linearGradient id="devGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7000ff"/><stop offset="100%" stopColor="#00f0ff"/></linearGradient></defs>
                    <rect x="15" y="25" width="70" height="55" rx="6" fill="#171717" stroke="url(#devGrad)" strokeWidth="2"/>
                    <line x1="15" y1="37" x2="85" y2="37" stroke="#333" strokeWidth="1.5"/>
                    <circle cx="23" cy="31" r="2" fill="#ff5f56"/>
                    <circle cx="29" cy="31" r="2" fill="#ffbd2e"/>
                    <circle cx="35" cy="31" r="2" fill="#27c93f"/>
                    <g transform="translate(25, 43)" stroke="#00f0ff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
                      <path d="M 10 6 L 2 12 L 10 18"/>
                      <path d="M 28 6 L 36 12 L 28 18"/>
                      <line x1="22" y1="4" x2="16" y2="20" stroke="#7000ff"/>
                    </g>
                    <g transform="translate(68, 58) scale(0.6)"><g className="spinning-cog"><circle cx="20" cy="20" r="14" fill="none" stroke="#7000ff" strokeWidth="4" strokeDasharray="6 4"/><circle cx="20" cy="20" r="6" fill="#171717" stroke="#7000ff" strokeWidth="1.5"/></g></g>
                  </svg>
                ),
              },
              {
                accent: "#ff007f", accentAlt: "#ff9900",
                badge: "Plug & Play", badgeBg: "rgba(255,0,127,0.1)", badgeBorder: "rgba(255,0,127,0.3)",
                title: "ReadyMade Platform",
                desc: "Buy a pre-built, launch-ready prototype — skip months of development and start generating revenue instantly.",
                tag: "Buy → Configure → Launch",
                svg: (
                  <svg className="service-svg" viewBox="0 0 100 100" width="72" height="72">
                    <defs><linearGradient id="readyGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#ff007f"/><stop offset="100%" stopColor="#ff9900"/></linearGradient></defs>
                    <g className="floating-illustration">
                      <polygon points="50,15 75,27 50,39 25,27" fill="url(#readyGrad)" opacity="0.85" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5"/>
                      <polygon points="25,27 50,39 50,69 25,57" fill="url(#readyGrad)" opacity="0.95" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5"/>
                      <polygon points="50,39 75,27 75,57 50,69" fill="#9e004f" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5"/>
                      <polygon points="50,15 37,21 37,33 50,27" fill="#ff5e00" opacity="0.8"/>
                    </g>
                    <path d="M 30,75 L 30,85 M 70,75 L 70,85 M 50,78 L 50,88" stroke="#ff007f" strokeWidth="2" strokeLinecap="round" opacity="0.6" className="blink-fast"/>
                    <circle cx="50" cy="22" r="3" fill="#ffea00" className="pulse-slow"/>
                  </svg>
                ),
              },
            ].map((svc, i) => (
              <motion.div
                key={svc.title}
                className="svc-card"
                style={{ "--svc-accent": svc.accent, "--svc-accent-alt": svc.accentAlt }}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: i * 0.09 }}
                onClick={handleServiceClick}
              >
                {/* Gradient top accent line */}
                <div className="svc-card-topline" style={{ background: `linear-gradient(90deg, ${svc.accent}, ${svc.accentAlt})` }} />

                {/* Card inner content */}
                <div className="svc-card-inner">
                  {/* Badge + Icon row */}
                  <div className="svc-card-top">
                    <span className="svc-badge" style={{ background: svc.badgeBg, color: svc.accent, borderColor: svc.badgeBorder }}>
                      <span className="svc-badge-dot" style={{ background: svc.accent }} />
                      {svc.badge}
                    </span>
                    <div className="svc-icon-wrap" style={{ background: svc.badgeBg, border: `1px solid ${svc.badgeBorder}` }}>
                      {svc.svg}
                    </div>
                  </div>

                  {/* Text */}
                  <h4 className="svc-card-title">{svc.title}</h4>
                  <p className="svc-card-desc">{svc.desc}</p>

                  {/* Tag / CTA footer */}
                  <div className="svc-card-footer">
                    <span className="svc-tag">{svc.tag}</span>
                    <span className="svc-arrow" style={{ color: svc.accent }}>→</span>
                  </div>
                </div>
              </motion.div>
            ))}

          </div>
        </div>
      </motion.section>

      {/* WHY MARSMATE — all 5 reasons visible in grid */}
      <motion.section
        id="why"
        className="why_section"
        variants={scrollReveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        <div className="why-grid-texture" />
        <div className="why-glow-orb" />

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="heading_container heading_center">
            <div><span className="section-pill">Why Us</span></div>
            <h2>
              <span className="text-dark">Why </span>
              <span className="marsmate-text">Marsmate</span>
            </h2>
          </div>

          <div className="why-all-grid">

            {/* Card 1 — Trust */}
            {[
              {
                color: "#C1440E", tag: "Trust & Data", tagBg: "rgba(193,68,14,0.1)", tagBorder: "rgba(193,68,14,0.25)",
                title: "Trust. Bridge. The Billionaire's Way.",
                desc: "At Marsmate, we turn ideas into innovation by reducing R&D effort through ready-to-launch technologies and intelligent validation tools.",
                svg: (
                  <svg viewBox="0 0 220 220" width="80" height="80" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <radialGradient id="wg1" cx="50%" cy="50%" r="50%"><stop offset="0%" stopColor="#C1440E" stopOpacity="0.22"/><stop offset="100%" stopColor="#C1440E" stopOpacity="0"/></radialGradient>
                    </defs>
                    <circle cx="110" cy="110" r="100" fill="url(#wg1)"/>
                    <ellipse cx="110" cy="110" rx="80" ry="30" fill="none" stroke="#C1440E" strokeWidth="1.2" strokeOpacity="0.3" strokeDasharray="6 4" className="why-orbit-1"/>
                    <ellipse cx="110" cy="110" rx="55" ry="55" fill="none" stroke="#E5622D" strokeWidth="1" strokeOpacity="0.22" strokeDasharray="4 6" className="why-orbit-2"/>
                    <circle cx="110" cy="110" r="30" fill="#C1440E" fillOpacity="0.12" stroke="#C1440E" strokeWidth="2"/>
                    <path d="M105 108 L109 112 L116 104" stroke="#C1440E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                    <circle r="5" fill="#C1440E"><animateMotion dur="4s" repeatCount="indefinite" path="M110,110 m-80,0 a80,30 0 1,1 160,0 a80,30 0 1,1 -160,0"/></circle>
                    <circle r="4" fill="#F5A623"><animateMotion dur="6s" repeatCount="indefinite" path="M110,110 m0,-55 a55,55 0 1,0 0.001,0"/></circle>
                  </svg>
                ),
              },
              {
                color: "#2563EB", tag: "Plug & Play", tagBg: "rgba(37,99,235,0.1)", tagBorder: "rgba(37,99,235,0.25)",
                title: "Ready-to-Use Tech Modules",
                desc: "Save time with instantly deployable plug & play technologies — skip months of R&D and go to market faster.",
                svg: (
                  <svg viewBox="0 0 220 220" width="80" height="80" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <radialGradient id="wg2" cx="50%" cy="50%" r="50%"><stop offset="0%" stopColor="#2563EB" stopOpacity="0.18"/><stop offset="100%" stopColor="#2563EB" stopOpacity="0"/></radialGradient>
                    </defs>
                    <circle cx="110" cy="110" r="100" fill="url(#wg2)"/>
                    {[0,1,2].map(row => [0,1,2].map(col => (
                      <rect key={`wg2-${row}-${col}`} x={62+col*36} y={62+row*36} width="28" height="28" rx="6"
                        fill={row===1&&col===1?"#2563EB":"#EFF6FF"} stroke="#2563EB" strokeWidth="1.2" strokeOpacity="0.5"
                        className="why-module-block" style={{animationDelay:`${(row*3+col)*0.12}s`}}/>
                    )))}
                    <circle r="5" fill="#10B981"><animateMotion dur="5s" repeatCount="indefinite" path="M110,110 m-52,0 a52,52 0 1,1 104,0 a52,52 0 1,1 -104,0"/></circle>
                  </svg>
                ),
              },
              {
                color: "#7C3AED", tag: "AI Engine", tagBg: "rgba(124,58,237,0.1)", tagBorder: "rgba(124,58,237,0.25)",
                title: "AI-Based Idea Validation",
                desc: "Validate, refine, and scale your business ideas with precision using our proprietary AI scoring and market analysis engine.",
                svg: (
                  <svg viewBox="0 0 220 220" width="80" height="80" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <radialGradient id="wg3" cx="50%" cy="50%" r="50%"><stop offset="0%" stopColor="#7C3AED" stopOpacity="0.2"/><stop offset="100%" stopColor="#7C3AED" stopOpacity="0"/></radialGradient>
                      <linearGradient id="wb1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#7C3AED"/><stop offset="100%" stopColor="#C4B5FD"/></linearGradient>
                      <linearGradient id="wb2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#C1440E"/><stop offset="100%" stopColor="#F5A623"/></linearGradient>
                    </defs>
                    <circle cx="110" cy="110" r="100" fill="url(#wg3)"/>
                    <rect x="60" y="150" width="16" height="40" rx="3" fill="url(#wb1)" className="why-bar"/>
                    <rect x="84" y="120" width="16" height="70" rx="3" fill="url(#wb1)" className="why-bar" style={{animationDelay:"0.2s"}}/>
                    <rect x="108" y="95" width="16" height="95" rx="3" fill="url(#wb2)" className="why-bar" style={{animationDelay:"0.4s"}}/>
                    <rect x="132" y="75" width="16" height="115" rx="3" fill="url(#wb2)" className="why-bar" style={{animationDelay:"0.6s"}}/>
                    <circle cx="110" cy="55" r="20" fill="#7C3AED" fillOpacity="0.18" stroke="#7C3AED" strokeWidth="1.5"/>
                    <text x="110" y="60" textAnchor="middle" fontSize="12" fill="#7C3AED" fontWeight="bold">AI</text>
                    <circle r="4" fill="#F5A623"><animateMotion dur="3s" repeatCount="indefinite" path="M110,55 m-20,0 a20,20 0 1,1 40,0 a20,20 0 1,1 -40,0"/></circle>
                  </svg>
                ),
              },
              {
                color: "#059669", tag: "Matchmaking", tagBg: "rgba(5,150,105,0.1)", tagBorder: "rgba(5,150,105,0.25)",
                title: "Funding & Tech Matchmaking",
                desc: "Bridge your startup to investors, mentors, and the right technologies through our intelligent matching network.",
                svg: (
                  <svg viewBox="0 0 220 220" width="80" height="80" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <radialGradient id="wg4" cx="50%" cy="50%" r="50%"><stop offset="0%" stopColor="#059669" stopOpacity="0.18"/><stop offset="100%" stopColor="#059669" stopOpacity="0"/></radialGradient>
                    </defs>
                    <circle cx="110" cy="110" r="100" fill="url(#wg4)"/>
                    <circle cx="110" cy="110" r="22" fill="#ECFDF5" stroke="#059669" strokeWidth="2"/>
                    <text x="110" y="115" textAnchor="middle" fontSize="14" fill="#059669">⟷</text>
                    {[0,60,120,180,240,300].map((angle, i) => {
                      const rad = (angle*Math.PI)/180;
                      const cx2=110+Math.round(60*Math.cos(rad)), cy2=110+Math.round(60*Math.sin(rad));
                      const colors=["#059669","#C1440E","#2563EB","#F59E0B","#7C3AED","#EC4899"];
                      return (<g key={i}><line x1="110" y1="110" x2={cx2} y2={cy2} stroke={colors[i]} strokeWidth="1" strokeOpacity="0.3" strokeDasharray="4 3"/><circle cx={cx2} cy={cy2} r="8" fill={colors[i]} fillOpacity="0.15" stroke={colors[i]} strokeWidth="1.5" className="why-pulse-dot" style={{animationDelay:`${i*0.3}s`}}/><circle cx={cx2} cy={cy2} r="3" fill={colors[i]}/></g>);
                    })}
                    <circle r="4" fill="#F59E0B" fillOpacity="0.9"><animateMotion dur="4s" repeatCount="indefinite" path="M110,110 l60,0 l-60,0"/></circle>
                  </svg>
                ),
              },
              {
                color: "#F5A623", tag: "End-to-End", tagBg: "rgba(245,166,35,0.1)", tagBorder: "rgba(245,166,35,0.28)",
                title: "End-to-End Startup Support",
                desc: "From idea to income, we guide every step — validation, build, launch, and scale. One platform, one journey.",
                svg: (
                  <svg viewBox="0 0 220 220" width="80" height="80" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <radialGradient id="wg5" cx="50%" cy="50%" r="50%"><stop offset="0%" stopColor="#C1440E" stopOpacity="0.14"/><stop offset="100%" stopColor="#C1440E" stopOpacity="0"/></radialGradient>
                      <linearGradient id="wroad" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stopColor="#C1440E"/><stop offset="50%" stopColor="#F5A623"/><stop offset="100%" stopColor="#10B981"/></linearGradient>
                    </defs>
                    <circle cx="110" cy="110" r="100" fill="url(#wg5)"/>
                    <path d="M40,160 Q80,80 110,110 Q140,140 180,60" fill="none" stroke="url(#wroad)" strokeWidth="3" strokeLinecap="round" strokeDasharray="200" className="why-road-draw"/>
                    {[[40,160,"💡"],[110,110,"🚀"],[180,60,"💰"]].map(([x,y,emoji],i)=>(
                      <g key={i}><circle cx={x} cy={y} r="14" fill="white" stroke={["#C1440E","#F5A623","#10B981"][i]} strokeWidth="2" className="why-milestone" style={{animationDelay:`${i*0.4}s`}}/><text x={x} y={y+5} textAnchor="middle" fontSize="11">{emoji}</text></g>
                    ))}
                    <circle r="5" fill="#C1440E"><animateMotion dur="4s" repeatCount="indefinite" path="M40,160 Q80,80 110,110 Q140,140 180,60"/></circle>
                  </svg>
                ),
              },
            ].map((card, i) => (
              <motion.div
                key={card.title}
                className="why-card"
                style={{ "--why-accent": card.color }}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
              >
                {/* Accent top border line */}
                <div className="why-card-top-line" style={{ background: `linear-gradient(90deg, ${card.color}, transparent)` }} />

                {/* Header row: badge + icon */}
                <div className="why-card-header">
                  <span className="why-card-badge" style={{ background: card.tagBg, color: card.color, borderColor: card.tagBorder }}>
                    <span className="why-badge-dot" style={{ background: card.color }} />
                    {card.tag}
                  </span>
                  <div className="why-card-svg-wrap">{card.svg}</div>
                </div>

                {/* Text */}
                <h3 className="why-card-title">{card.title}</h3>
                <p className="why-card-desc">{card.desc}</p>
              </motion.div>
            ))}

          </div>
        </div>
      </motion.section>


      {/* CLIENTS */}
    <motion.section
  id="clients"
  className="team_section layout_padding"
  variants={scrollReveal}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
>

        <div className="container-fluid">
          <div className="heading_container heading_center">
            <div><span className="section-pill">Trusted By</span></div>
            <h2>
              <span className="text-black">Our </span>
             <span className="clients-text">Clients</span>
            </h2>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="box">
                <div className="img-box">
                  <img src="/image/client-2.png" alt="client-2" />
                </div>
                <h5 className="text-lightsky mt-3">
                  Mahalaksh Connects Pvt Ltd
                </h5>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="box">
                <div className="img-box">
                  <img src="/image/client-1.png" alt="client-1" />
                </div>
                <h5 className="text-lightsky mt-3">Metalokas IT Pvt Ltd</h5>
              </div>
            </div>
          </div>
        </div>
     </motion.section>


    <motion.section
  id="getintouch"
  className="getintouch_section"
  variants={scrollReveal}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
 <div className="heading_container heading_center">
    <h2>
      Your <span>Requirements</span>
    </h2>

  </div>

  <FormsScroll />
</motion.section>




      <section id="footer">
          <Footer onBookConsultant={() => setIsBookConsultantOpen(true)} />
      </section>

    

    
      {/* BOOK CONSULTANT — POPUP CALLBACK FIXED */}
       <div className="total-visitors">
            <span className="visitor-label">Total Visitors</span>

            <div className="digit-container">
              {String(visitCount)
                .padStart(1, "0")
                .split("")
                .map((digit, index) => (
                  <span key={index} className="digit-box">
                    {digit}
                  </span>
                ))}
            </div>
      </div>
      <BookConsultant
        setShowPopup={setShowPopup}
        hideButton={true}
        isOpen={isBookConsultantOpen}
        setIsOpen={setIsBookConsultantOpen}
      />
      <AuthContainer
  isOpen={showLogin} 
  onClose={() => setShowLogin(false)} 
  initialMode={initialAuthMode} // Add this prop
/>

      {/* LOGIN MODAL */}
      {/* <Login isOpen={showLogin} onClose={() => setShowLogin(false)} /> */}
    </>
  );
};
export default Home;
